// The "Upvote Rhuna on ProductHunt" quest is featured at the top of /quests
// and surfaced via a banner on /quests and the landing page.
export const FEATURED_TASK_GUID = "642ee463-87a6-4c24-8751-840672cb0ddd";
export const FEATURED_TASK_TYPE = "Product Challenges";
export const FEATURED_TASK_URL = "https://www.producthunt.com/products/rhuna";

// Additional tasks featured by GUID alongside the Product Challenges section,
// since they belong to other categories (e.g. Special Challenges).
export const PULSAR_WAITLIST_TASK_GUID = "fc2d67ad-4c08-4e26-b5c9-71d38ff6ea6b";
export const EXTRA_FEATURED_TASK_GUIDS: string[] = [PULSAR_WAITLIST_TASK_GUID];

export const FEATURED_TASK_STEP_IMAGES = {
  step2: "https://pulsarmoney.b-cdn.net/rhuna/rhuna1.png",
  step3: "https://pulsarmoney.b-cdn.net/rhuna/rhuna2.png",
} as const;
